<template>
  <page-template :card="card">
    <template slot="title">
      <page-title
        v-if="!pageTitleComponent"
        :title="$t(pageTitle)"
        :navigate-back-route="navigateBackRoute"
      />
      <component
        :is="pageTitleComponent"
        v-if="pageTitleComponent"
        :navigate-back-route="navigateBackRoute"
      />
    </template>
    <template slot="primaryActions">
      <component
        :is="filterComponent"
        :options="filterOptions"
      />
      <v-spacer />
      <component
        :is="filterDialogComponent"
        :options="filterOptions"
      />
      <component
        :is="component"
        v-for="(component, i) in anyComponent"
        :key="`anyComponent_${i}`"
        :options="filterOptions"
      />
      <btn-add-crud-list
        v-if="newRouteName"
        :text="$t(btnText)"
        icon="add_circle_outline"
        @click="navigateTo(newRouteName)"
      />
    </template>
    <template slot="content">
      <component :is="pageContent" />
    </template>
  </page-template>
</template>

<script>
import BtnAddCrudList from 'Support/components/buttons/BtnAddCrudList.vue';
import PageTemplate from 'Support/layout/PageTemplate.vue';
import PageTitle from 'Support/layout/PageTitle.vue';
import RouterMixin from 'Support/mixins/router-mixin';

export default {
  name: 'CrudListTemplate',
  components: {
    BtnAddCrudList,
    PageTemplate,
    PageTitle,
  },
  mixins: [RouterMixin],
  computed: {
    card() {
      return this.$route.meta.crud.showCard && true;
    },
    filterComponent() {
      return this.$route.meta.crud.filterComponent;
    },
    anyComponent() {
      const { crud = {} } = this.$route.meta;
      const components = Object.keys(
        crud,
      ).filter(
        key => key.includes('anyComponent'),
      ).map(
        key => crud[key],
      );
      return components;
    },
    filterDialogComponent() {
      return this.$route.meta.crud.filterDialogComponent;
    },
    filterOptions() {
      return this.$route.meta.crud.filterOptions;
    },
    pageTitle() {
      return this.$route.meta.crud.pageTitle;
    },
    pageTitleComponent() {
      return this.$route.meta.crud.pageTitleComponent;
    },
    navigateBackRoute() {
      return this.$route.meta.crud.navigateBackRoute;
    },
    btnText() {
      return this.$route.meta.crud.btnText;
    },
    newRouteName() {
      return this.$route.meta.crud.newRouteName;
    },
    pageContent() {
      return this.$route.meta.crud.pageContent;
    },
  },
};
</script>
